<template>
  <input-select
    v-if="catalogId"
    class="mb-1"
    :value="value"
    :disabled="disabled"
    :options="sizeOptions"
    placeholder="Select a size"
    @input="(v) => this.$emit('input', v)"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import InputSelect from '@/components/Form/InputSelect';

export default {
  name: "SizeOption",
  components: {
    InputSelect,
  },
  props: [
    "catalogId",
    "value",
    "disabled",
  ],
  computed: {
    ...mapGetters({
      mockupOptions: "upload/mockupOptions",
    }),
    sizeOptions() {
      const catalogType = this.mockupOptions.find(item => Number(item.value) === Number(this.catalogId));
      return catalogType.sizes || [];
    },
  },
};
</script>
